import { Box } from '@mui/material';
import React from 'react';
import FundTotalItem from './FundTotalItem';
import { useAppSelector } from '../../../../store/reducers/store';
import {ReactComponent as walletIcon} from '../../../../assets/wallet.svg'
import {ReactComponent as ceuroIcon} from '../../../../assets/c_euro.svg'
import {ReactComponent as giveIcon} from '../../../../assets/dashboard_central_icon.svg'
import {ReactComponent as swapIcon} from '../../../../assets/swap_light.svg'
import {ReactComponent as moneyIcon} from '../../../../assets/money_light.svg'
import {ReactComponent as stackIcon} from '../../../../assets/stack_light.svg'
import { useTranslation } from 'react-i18next';

const FundTotal: React.FC = () => {
    const portfolio = useAppSelector(state => state.portfolioDetails.portfolio);
    const {t, i18n} = useTranslation();

    if (portfolio === undefined){
        return <></>;
    }

    return <Box width={"100%"} display={"flex"} gap={"25px"}>
        <FundTotalItem title={t('PortfolioDetailsTotalNumberOfFunds')} content={`${portfolio.funds.length}`} icon={walletIcon} />
        <FundTotalItem title={t('PortfolioDetailsTotalCapitalCommited')} content={`€ ${portfolio.funds.reduce((a, b) => a + b.proportion * portfolio.fundraisingTarget, 0).toLocaleString(i18n.language)}`} icon={ceuroIcon} />
        <FundTotalItem title={t('PortfolioDetailsTotalCapitalCalled')} content={`€ ${portfolio.funds.reduce((a, b) => a + b.capitalCalled, 0).toLocaleString(i18n.language)}`} icon={giveIcon} />
        <FundTotalItem title={t('PortfolioDetailsTotalMOIC')} content={`${portfolio.moic.toFixed(1)}`} icon={swapIcon} />
        <FundTotalItem title={t('PortfolioDetailsTotalDPI')} content={`${portfolio.dpi.toFixed(1)}`} icon={moneyIcon} />
        <FundTotalItem title={t('PortfolioDetailsTotalNetAssetValue')} content={`€ ${portfolio.funds.reduce((a, b) => a + b.netWorthValue, 0).toLocaleString(i18n.language)}`} icon={stackIcon} />
    </Box>;
}

export default FundTotal;